export const socialsData = {
    github: 'https://github.com/Satheeshraj05',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/satheesh-raj/',
    instagram: 'https://www.instagram.com/sa3sh.r/',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}
